var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "form-content", attrs: { id: "wizard-step-1" } },
    [
      _c("sc-form", {
        attrs: { form: _vm.formContent, "has-style": false, rules: _vm.rules },
        on: {
          submit: function(val) {
            return _vm.$emit("onNextStep", val)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c(
                  "section",
                  { staticClass: "upload-form" },
                  [
                    _c(
                      "sc-field",
                      {
                        staticClass: "upload-form__step",
                        attrs: { id: "template-step-1", prop: "lpAndDmInfo" }
                      },
                      [
                        _c(
                          "template",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "span",
                              { staticClass: "upload-form__step__label" },
                              [
                                _c(
                                  "sc-tag",
                                  { attrs: { size: "is-medium", rounded: "" } },
                                  [_vm._v("1")]
                                ),
                                _vm._v(
                                  "\n              Transportadora e método de entrega\n            "
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-select",
                          {
                            attrs: {
                              size: "is-medium",
                              disabled: _vm.loadingLogisticProviders,
                              placeholder: "Transportadora e método de entrega",
                              expanded: ""
                            },
                            model: {
                              value: fields.lpAndDmInfo,
                              callback: function($$v) {
                                _vm.$set(fields, "lpAndDmInfo", $$v)
                              },
                              expression: "fields.lpAndDmInfo"
                            }
                          },
                          _vm._l(_vm.allDeliveryMethods, function(dm) {
                            return _c(
                              "option",
                              { key: dm.id, domProps: { value: dm } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(dm.logistic_provider_name) +
                                    " - " +
                                    _vm._s(dm.name) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-field",
                      {
                        staticClass: "upload-form__step",
                        attrs: { id: "template-step-2", prop: "name" }
                      },
                      [
                        _c(
                          "template",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "span",
                              { staticClass: "upload-form__step__label" },
                              [
                                _c(
                                  "sc-tag",
                                  { attrs: { size: "is-medium", rounded: "" } },
                                  [_vm._v("2")]
                                ),
                                _vm._v(
                                  "\n              Nome do modelo da fatura\n            "
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("sc-input", {
                          attrs: {
                            size: "is-medium",
                            placeholder: "Ex: Fatura transportadora ABC"
                          },
                          model: {
                            value: fields.name,
                            callback: function($$v) {
                              _vm.$set(fields, "name", $$v)
                            },
                            expression: "fields.name"
                          }
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-field",
                      {
                        staticClass: "upload-form__step",
                        attrs: { id: "template-step-3", prop: "previewFile" }
                      },
                      [
                        _c(
                          "template",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "span",
                              { staticClass: "upload-form__step__label" },
                              [
                                _c(
                                  "sc-tag",
                                  { attrs: { size: "is-medium", rounded: "" } },
                                  [_vm._v("3")]
                                ),
                                _vm._v(
                                  "\n              Upload do arquivo do modelo de fatura\n            "
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-simple-upload",
                          {
                            attrs: {
                              accept:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                              expanded: "",
                              "drag-drop": ""
                            },
                            model: {
                              value: fields.previewFile,
                              callback: function($$v) {
                                _vm.$set(fields, "previewFile", $$v)
                              },
                              expression: "fields.previewFile"
                            }
                          },
                          [
                            _c(
                              "a",
                              { staticClass: "button is-fullwidth is-medium" },
                              [
                                fields.previewFile
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "sc-tag",
                                          {
                                            staticClass: "selected-file",
                                            attrs: { size: "is-medium" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  fields.previewFile.name
                                                ) +
                                                "\n                  "
                                            ),
                                            _c("button", {
                                              staticClass: "delete is-small",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function() {
                                                  return (fields.previewFile = null)
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _c("span", [
                                      _c("i", {
                                        staticClass: "fas fa-upload",
                                        staticStyle: { "margin-right": ".5em" }
                                      }),
                                      _vm._v(
                                        "\n                Arraste um arquivo ou "
                                      ),
                                      _c("strong", [_vm._v("clique")]),
                                      _vm._v(" para buscar\n              ")
                                    ])
                              ]
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _c(
                  "section",
                  { staticClass: "continue-buttom" },
                  [
                    _c("sc-button", {
                      attrs: {
                        theme: "primary",
                        type: "submit",
                        text: "Continuar"
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2705e6a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2705e6a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateStep1.vue
// module id = null
// module chunks = 